import { useEffect } from 'react';

import { PageState } from 'providers/filtersUtils';
import { SearchMarketplaceItemsParams } from 'services/search/searchService.dto';
import { useSearchItems } from 'services/search/useSearchItems';

const FEATURED_ITEMS_COUNT = 5;
const PAGE_SIZE = 12;

export const useFeaturedItems = () => useSearchItems({ sortType: 'RELEVANT', page: 0, size: FEATURED_ITEMS_COUNT });

export const useItems = (filters: SearchMarketplaceItemsParams, pageState: PageState) => {
  const pageSize = filters.size ?? PAGE_SIZE;

  const items = useSearchItems({
    sortType: filters.sortType,
    size: pageSize,
    page: 0,
    lat: filters.lat,
    lon: filters.lon,
    nationwideShipping: filters.nationwideShipping,
    localPickup: filters.localPickup,
    categoryCode: filters.categoryCode,
    sellingMethod: filters.sellingMethod,
    conditionCode: filters.conditionCode,
    radius: filters.radius,
    priceTo: filters.priceTo,
    priceFrom: filters.priceFrom,
    searchPhrase: filters.searchPhrase,
    ...(filters.sortType === 'RELEVANT' && pageState === 'Default' && { offset: FEATURED_ITEMS_COUNT }),
  });

  const { refresh } = items;

  useEffect(() => {
    refresh();
  }, [filters]);

  return items;
};

export const useHomeItems = (itemsCount: number) => {
  const homeItems = useSearchItems({
    sortType: 'RELEVANT',
    page: 0,
    size: itemsCount,
  });

  const { refresh } = homeItems;

  useEffect(() => {
    refresh();
  }, [itemsCount]);

  return homeItems;
};
